<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>
          Valor a pagar {{ moneyFormat(modelValue.pago.amt_total_a_pagar, 2) }}
          &emsp;
          Valor digitado {{ moneyFormat(valor, 2) }}
        </h3>
      </div>
    </div>
    <div class="row">
      <!-- <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field stretch vMoney :format="money" readonly id="valor" placeholder="##.##" :value="valor">
            <span>Valor</span>
          </input-field>
        </div>
      </div> -->
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field stretch vMoney :format="money" id="efectivo" placeholder="##.##" v-model="modelValue.pago.efectivo">
            <span>Efectivo</span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field stretch vMoney :format="money" id="transferencia" placeholder="##.##"
            v-model="modelValue.pago.transferencia">
            <span>Transferencia</span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field stretch vMoney :format="money" id="deposito" placeholder="##.##" v-model="modelValue.pago.deposito">
            <span>Depósito</span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <input-field stretch id="ref_deposito" placeholder="##.##" v-model="modelValue.pago.ref_deposito">
            <span>Referencia depósito</span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-8">
        <div class="form-field">
          <div class="datepicker-field">
            <VueCtkDateTimePicker id="fecha_proximo_pago" v-model="modelValue.fecha_proximo_pago" locale="es" no-label only-date
              button-now-translation="Ahora" format="YYYY-MM-DD" formatted="YYYY-MM-DD" label="Seleccione una fecha..." noClearButton :disabled-weekly="[0]"
            />
            <label>Generar recibo pago adelantado</label>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="form-field">
          <div class="file-upload-field">
            <label>Archivo</label>
            <button @click="eliminarArchivo()" class="btn-warning" type="button"
              v-show="modelValue.pago.url_archivo != null || modelValue.pago.archivo != null">
              <i class="fa fa-trash"></i>
            </button>
            <button @click="descargarArchivo()" class="btn-info" type="button"
              v-show="modelValue.pago.url_archivo != null && modelValue.pago.archivo == null">
              <i class="fa fa-download"></i>
            </button>
            <fileUpload :id="'archivo'" ref="archivo" :extensiones="'.JPEG,.gif,.jpg,.png,.PNG,.JPG'"
              :defaultImage="modelValue.pago.url_archivo != null ? modelValue.pago.url_archivo : '/images/no-logo.png'"
              :pathDefault="'/images/no-logo.png'" @imagenCargada="setearArchivo()" :tamanoMaximo="5000000"
              :descripcionMaximo="'5mb'" verMiniatura>
            </fileUpload>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-8">
        <textarea-field placeholder="Escriba una observación" id="observaciones" v-model="modelValue.pago.observaciones">
          <span>Observaciones</span>
        </textarea-field>
      </div>
    </div>
    <div class="modal-buttons">
      <button class="btn-success" @click="abonar">
        <i class="fa fa-save"></i><span>Abonar</span>
      </button>
      <button class="btn-danger btn--text" @click="$emit('cerrar')">
        <i class="fa fa-times"></i><span>Cancelar</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: false,
      type: Object,
      default: function () {
        return {};
      },
    },
    fechaRutaCobro: {
      required: false,
      default: null
    }
  },
  data: function () {
    return {
      modelValue: this.value,
      money: money,
      moneyFormat: moneyFormat,
    };
  },
  methods: {
    setearArchivo: function () {
      this.modelValue.pago.archivo = this.$refs.archivo.recuperarImagen();
    },
    abonar: function () {
      const esValido = this.validar();
      if (!esValido) return;
      swal({
        title: "¿Desea guardar?",
        text: "Se requiere confirmación",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          this.$emit("input", this.modelValue)
        }
      });
    },
    validar: function () {
      if(!this.modelValue.fecha_proximo_pago) {
        swal("La fecha de generar recibo de pago adelantado es obligatorio", "Aviso", "warning");
        return false;
      }
      const fechaProximoPago = moment(this.modelValue.fecha_proximo_pago, 'YYYY-MM-DD');
      const fechaRuta = moment(this.fechaRutaCobro, 'YYYY-MM-DD');
      if (fechaProximoPago.isSameOrBefore(fechaRuta)) {
        swal("La fecha de próximo pago no puede ser menor o igual a la fecha de la ruta", "Aviso", "warning");
        return false;
      }
      let valor = parseFloat(this.modelValue.pago.valor);
      if (isNaN(valor)) valor = 0;
      let amt_total_a_pagar = round(parseFloat(this.modelValue.pago.amt_total_a_pagar), 2);
      if (isNaN(amt_total_a_pagar)) amt_total_a_pagar = 0;
      if (valor != amt_total_a_pagar) {
        swal(
          "El valor digitado no puede ser diferente al valor a pagar.",
          "Aviso",
          "warning"
        );
        return false;
      }
      return true;
    },
    eliminarArchivo: function () {
      let that = this;
      swal({
        title: "¿Desea eliminar la foto?",
        text: "",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
      }).then((result) => {
        if (result.value) {
          that.modelValue.pago.archivo = null;
          that.modelValue.pago.url_archivo = null;
          that.$refs.archivo.setDefaultImage();
          that.$forceUpdate();
        }
      });
    },
    descargarArchivo: function () {
      swal
        .fire({
          title: "¿Desea descargar la foto?",
          text: "",
          type: "question",
          showCancelButton: true,
          confirmButtonText: "Aceptar",
        })
        .then((result) => {
          if (result.value) {
            let urlApi = url + "/rutas-cobros/descargar-archivo/" + this.modelValue.pago.id;
            window.open(urlApi, "_blank");
          }
        });
    },
  },
  computed: {
    valor: function () {
      let efectivo = parseFloat(this.modelValue.pago.efectivo);
      if (isNaN(efectivo)) efectivo = 0;
      let transferencia = parseFloat(this.modelValue.pago.transferencia);
      if (isNaN(transferencia)) transferencia = 0;
      let deposito = parseFloat(this.modelValue.pago.deposito);
      if (isNaN(deposito)) deposito = 0;
      this.modelValue.pago.valor = efectivo + transferencia + deposito;
      return this.modelValue.pago.valor;
    },
  },
  mounted: function () { 
    if(this.modelValue.pago.deposito == 0 && this.modelValue.pago.transferencia == 0)
      this.modelValue.pago.efectivo = this.modelValue.pago.amt_total_a_pagar;
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/prestamos/cobros/ModalAmtPago.vue